export type RoleName = 'admin' | 'analyst' | 'readonly';

export const ROLE_OPTIONS = [
  { value: 'admin' as const, label: 'Admin' },
  { value: 'analyst' as const, label: 'Analyst' },
  { value: 'readonly' as const, label: 'Read Only' },
] as const;

export function formatRoleName(role?: string): string {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'analyst':
      return 'Analyst';
    case 'readonly':
      return 'Read Only';
    default:
      return 'Read Only';
  }
}

export function getRoleChipStyle(
  role?: string
): 'primary' | 'secondary' | 'default' {
  switch (role) {
    case 'admin':
      return 'primary';
    case 'analyst':
      return 'secondary';
    default:
      return 'default';
  }
}
